import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Blog.css';
import { getPath } from '../utils/functions';

function BlogPost({ blog }) {
  // Track the current window width.
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Decide how many characters to display based on screen width.
  let maxChars = 120;
  if (windowWidth > 768 && windowWidth <= 1024) {
    maxChars = 100;
  } else if (windowWidth <= 768) {
    maxChars = 80;
  }

  // For truncation logic
  const isLong = blog.subtitle.length > maxChars;
  const displaySubtitle = isLong
    ? blog.subtitle.slice(0, maxChars).trim() + '...'
    : blog.subtitle;

  // Build the detail page path once
  const detailPath = getPath(
    `/blogs/${blog.searchName.toLowerCase().split(' ').join('-')}`
  );

  // Whole-card navigation, except when clicking on links (tags / More)
  const handleCardClick = (e) => {
    if (e.target.closest('a')) return;
    navigate(detailPath);
  };

  // If no image URL, use local fallback
  if (!blog.image_url) {
    blog.image_url = `/Images/blogs/${blog.id}.png`;
  }

  return (
    <div className="blog-post" onClick={handleCardClick}>
      {/* Image container remains a div to preserve layout */}
      <div className="blog-image-container">
        <Link to={detailPath}>
          <img
            src={blog.image_url}
            alt={blog.title}
            className="blog-img"
          />
        </Link>
      </div>

      <div className="blog-text-container">
        {/* Tags row */}
        <div className="blog-tags">
          {blog.tag?.map((tag) => (
            <Link
              key={tag}
              to={getPath(`/blogs?tag=${encodeURIComponent(tag)}`)}
              className="blog-tag-pill"
            >
              {tag}
            </Link>
          ))}
        </div>

        {/* Title */}
        <div className="blog-title-container">
          <Link to={detailPath} className="blog-title-link">
            <h3 className="blog-title">{blog.title}</h3>
          </Link>
        </div>

        {/* Truncated Content */}
        <div className="blog-content-container">
          <p className="blog-content">{displaySubtitle}</p>
        </div>

        {/* "More" link at the bottom */}
        <div className="blog-more-btn-container">
          <Link to={detailPath} className="blog-more-btn">
            More <mark className="gray">&gt;</mark>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BlogPost;
